export enum LogoutType {
    TokenExpired = 'token_expired',
    SessionTokenExpired = 'session_token_expired',
    Manually = 'manually',
    ByServer = 'by_server'
}
